<div [ngClass]="{ 'w-full h-dvh': true }">
  <div
    [ngClass]="{ 'h-svh w-full flex flex-1': true }"
    style="
      background-image: url(&quot;/assets/login-assets/tsp-login-bg.jpg&quot;);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    "
  >
    <div
      [ngClass]="{
        'overflow-hidden flex-1 px-4 md:px-9 py-10 flex flex-col items-center relative': true,
      }"
    >
      <div class="w-full absolute top-5 left-20">
        <app-back-button-route className="!text-white"></app-back-button-route>
      </div>

      <div class="min-h-full flex flex-col items-center justify-center w-full">
        <div
          class="w-full p-4 md:p-8 bg-white rounded-2xl max-w-[540px] mx-auto mt-10 space-y-6"
        >
          <div
            class="flex items-center justify-center mt-10 cursor-pointer"
            (click)="router.navigate(['/'])"
          >
            <img
              [ngSrc]="'assets/login-assets/pay_kaduna_icon.png'"
              alt="primeguage-logo"
              priority
              width="62"
              height="52.5"
              [ngClass]="{ 'h-[52.5px] w-[62px]': true }"
            />
            <p
              [ngClass]="{
                'text-[#292929] text-[20px] leading-[150%] -tracking-[1px] font-extrabold': true,
              }"
            >
              PAYKADUNA
            </p>
          </div>

          <div
            [ngClass]="{
              'flex flex-col items-center justify-center gap-2': true,
            }"
          >
            <h3
              [ngClass]="{
                'text-[#292929] font-bold text-lg text-center': true,
              }"
            >
              Technical Service Providers
            </h3>

            <p class="text-[#4B5563] text-base text-center">
              TSP Partner Integration Gateway
            </p>
          </div>

          <div>
            <form
              [formGroup]="authForm"
              (ngSubmit)="onSubmit()"
              class="flex flex-col flex-1 w-full p-4"
            >
              <div class="flex flex-col gap-6 pb-4">
                <div class="w-full mx-auto">
                  <label for="" class="flex flex-col">
                    <div class="relative flex w-full">
                      <!-- <input appGeneralInput type='email' placeholder="Enter email" formControlName="email" /> -->
                      <app-general-input
                        label="Email"
                        type="email"
                        placeholder="Enter email"
                        controlName="email"
                        [formGroup]="authForm"
                      ></app-general-input>

                      <div
                        *ngIf="
                          !!authForm.get('email')?.errors &&
                          authForm.get('email')?.touched
                        "
                        class="absolute top-[calc(100%+1px)] text-[12px] pl-[5px] text-[#EB5757] flex items-center gap-[4px]"
                      >
                        <span *ngIf="authForm.get('email')?.errors?.email">{{
                          "Invalid email"
                        }}</span>
                        <span *ngIf="authForm.get('email')?.errors?.required"
                          >Field is required</span
                        >
                      </div>
                    </div>
                  </label>
                </div>
                <div class="w-full mx-auto">
                  <label for="" class="flex flex-col">
                    <div class="relative flex w-full">
                      <app-password-input
                        label="Password"
                        placeholder="Enter password"
                        controlName="password"
                        [formGroup]="authForm"
                      ></app-password-input>

                      <div
                        class="absolute top-[calc(100%+1px)] text-[12px] pl-[5px] text-[#EB5757] flex items-center gap-[4px]"
                        *ngIf="
                          !!authForm.get('password')?.errors &&
                          authForm.get('password')?.touched
                        "
                      >
                        <span *ngIf="authForm.get('password')?.errors?.required"
                          >Field is required</span
                        >
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <div [ngClass]="{ 'flex justify-between pt-4': true }">
                <label nz-checkbox formControlName="rememberMe">
                  Remember me
                </label>

                <button
                  type="button"
                  class="text-sm leading-6 text-primary-500 underline-offset-[3px] text-center font-bold"
                  [routerLink]="['/forgot-password']"
                  [queryParams]="{ returnUrl: '/tsp' }"
                >
                  Forgot password?
                </button>
              </div>

              <div class="mt-auto text-center pt-6">
                <button
                  appGeneralButton
                  type="submit"
                  [disabled]="mutation.isPending()"
                  [ngClass]="{
                    'disabled:opacity-50 !bg-primary-500 capitalize': true,
                  }"
                >
                  {{
                    mutation.isPending()
                      ? "Logging in.\
                    Please\
                    wait..."
                      : "Sign In"
                  }}
                </button>
              </div>
            </form>
          </div>

          <p class="text-center">
            PayKaduna... setting the pace in Tax Administration
          </p>
        </div>
      </div>
    </div>
  </div>

</div>
